import type { Variants } from "framer-motion";

/** Subtle fade-and-slide-up entrance used by the homepage Leadership Gap section. */
export const gapContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07, delayChildren: 0.05 } },
};

export const gapItem: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export const gapItemStatic: Variants = {
  hidden: { opacity: 1, y: 0 },
  visible: { opacity: 1, y: 0, transition: { duration: 0 } },
};

export const gapViewport = {
  once: true,
  amount: 0.05,
} as const;
